import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { UpdateSurveySettingsRPC } from "./updateSurveySettingsRPC";

export class UpdateSurveySettingsRPCClientImpl extends UpdateSurveySettingsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: UpdateSurveySettingsRPC.Request): Promise<LeoRPCResult<UpdateSurveySettingsRPC.Response, UpdateSurveySettingsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/UpdateSurveySettings",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      UpdateSurveySettingsRPC.ResponseDTO,
      UpdateSurveySettingsRPC.Errors.ErrorsDTO,
      UpdateSurveySettingsRPC.Response,
      UpdateSurveySettingsRPC.Errors.Errors
    >(
      response,
      "survey/UpdateSurveySettings",
      UpdateSurveySettingsRPC.Response.fromDTO,
      UpdateSurveySettingsRPC.Errors.fromDTO
    );
  }
}
